// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanScheduledContributionDto } from './IPlanScheduledContributionDto';
import {
    IPlanScheduledContributionDtoFromJSON,
    IPlanScheduledContributionDtoFromJSONTyped,
    IPlanScheduledContributionDtoToJSON,
    IPlanScheduledContributionDtoToJSONTyped,
} from './IPlanScheduledContributionDto';

/**
 * 
 * @export
 * @interface IEmployeeScheduledContributionDto
 */
export interface IEmployeeScheduledContributionDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeScheduledContributionDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeScheduledContributionDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeScheduledContributionDto
     */
    last_name?: string;
    /**
     * 
     * @type {Array<IPlanScheduledContributionDto>}
     * @memberof IEmployeeScheduledContributionDto
     */
    plans?: Array<IPlanScheduledContributionDto>;
}

/**
 * Check if a given object implements the IEmployeeScheduledContributionDto interface.
 */
export function instanceOfIEmployeeScheduledContributionDto(value: object): value is IEmployeeScheduledContributionDto {
    return true;
}

export function IEmployeeScheduledContributionDtoFromJSON(json: any): IEmployeeScheduledContributionDto {
    return IEmployeeScheduledContributionDtoFromJSONTyped(json, false);
}

export function IEmployeeScheduledContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeScheduledContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanScheduledContributionDtoFromJSON)),
    };
}

export function IEmployeeScheduledContributionDtoToJSON(json: any): IEmployeeScheduledContributionDto {
    return IEmployeeScheduledContributionDtoToJSONTyped(json, false);
}

export function IEmployeeScheduledContributionDtoToJSONTyped(value?: IEmployeeScheduledContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanScheduledContributionDtoToJSON)),
    };
}

